module.exports = __webpack_public_path__ + "img/medalha-sustentabilidade.bb0e2685.jpeg";